import React from 'react';
import { Control, UseFormSetValue, UseFormWatch, FieldErrors } from 'react-hook-form';
import { IdentificationFieldset, SignedContractsFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";
import { CollaboratorDpDocuments } from '@/features/DpRequests/components/CollaboratorDpDocuments';

interface DocumentsTabProps {
    context: CollaboratorFormContext;
    collaboratorId: string;
    control: Control<CollaboratorFormData>;
    setValue: UseFormSetValue<CollaboratorFormData>;
    watch: UseFormWatch<CollaboratorFormData>;
    errors: FieldErrors<CollaboratorFormData>;
    isSubmitting?: boolean;
}

const DocumentsTab: React.FC<DocumentsTabProps> = ({
    context,
    collaboratorId,
    control,
    setValue,
    watch,
    errors,
    isSubmitting = false
}) => {
    return (
        <div className="space-y-6">
            <IdentificationFieldset
                context={context}
                collaboratorId={collaboratorId}
                control={control}
                setValue={setValue}
                watch={watch}
                errors={errors}
                isSubmitting={isSubmitting}
            />

            <SignedContractsFieldset
                context={context}
                collaboratorId={collaboratorId}
                control={control}
                setValue={setValue}
                watch={watch}
                errors={errors}
                isSubmitting={isSubmitting}
            />
            <CollaboratorDpDocuments collaboratorId={collaboratorId} />
        </div>
    );
};

export default DocumentsTab;
